import { css } from '@emotion/react';
import Spacings, { createCustomSpacing, } from '@polestar/component-warehouse-react/tokens/spacings/Spacings';
import { MegaMenuCSSCustomProperties, fadeTransitions, linkHoverTransition, } from './MegaMenu.config';
import FontSizes from '@polestar/component-warehouse-react/tokens/font-sizes/FontSizes';
import LineHeights from '@polestar/component-warehouse-react/tokens/line-heights/LineHeights';
import LetterSpacings from '@polestar/component-warehouse-react/tokens/letter-spacings/LetterSpacings';
import { createCSSPropertyTransition } from '@polestar/component-warehouse-react/tokens/motion/Motion';
import MediaQueries from '@polestar/component-warehouse-react/tokens/media-queries/MediaQueries';
export const linkStyle = css `
  text-decoration: none;
  font-size: ${FontSizes.large};
  line-height: ${createCustomSpacing(30 / 16)};
  letter-spacing: ${LetterSpacings.large};
  color: currentColor;
  transition: ${createCSSPropertyTransition('color', fadeTransitions)}, ${linkHoverTransition};
`;
export const labelTextStyle = css `
  text-decoration: none;
  font-size: ${FontSizes.body};
  line-height: ${LineHeights.small};
  letter-spacing: ${LetterSpacings.small};
  color: currentColor;
  transition: ${createCSSPropertyTransition('color', fadeTransitions)}, ${linkHoverTransition};
`;
// todo: I think we should reconsider how we are transitioning our Header
// TBH: I think we should animate/set `MegaMenuCSSCustomProperties.hideHeader` in JS
export const disappearingHeaderTranslateStyle = css `
  translate: 0
    calc(
      ((var(${MegaMenuCSSCustomProperties.blockSize}, 100%) + ${createCustomSpacing(1 / 16)}) * -1) *
        var(${MegaMenuCSSCustomProperties.hideHeader}, 0)
    );
`;
export const visuallyHidden = css `
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  block-size: ${createCustomSpacing(1 / 16)};
  inline-size: ${createCustomSpacing(1 / 16)};
  overflow: hidden;
  position: absolute;
  white-space: nowrap;
`;
/*
 * @internal
 * TODO: Review and discuss with the team
 *  - Naming
 *  - Where to place this file
 *  - Expose it for people to use
 *  - Should these be presented as custom props
 */
/*
 * The setup of sections is now using a max-width + padding on the parent and child
 * This makes it tricky to use on a single element
 * This can be fixed by extending the parent's max-width
 * This is why `maxInlineSize` is using 1824 instead of `1760`
 * The difference is 2x 2rem padding
 */
export const maxInlineSize = createCustomSpacing(1824 / 16);
export const mobileInlinePadding = '6vw';
export const tabletInlinePadding = Spacings.xxLarge;
export const desktopInlinePadding = Spacings.xxxLarge;
export const desktopWideInlinePadding = createCustomSpacing(7);
export const sectionLayoutStyles = css `
  inline-size: min(100%, ${maxInlineSize});
  margin-inline: auto;
  padding-inline: ${mobileInlinePadding};

  ${MediaQueries.tablet} {
    padding-inline: ${tabletInlinePadding};
  }

  ${MediaQueries.desktop} {
    padding-inline: ${desktopInlinePadding};
  }

  ${MediaQueries.desktopWide} {
    padding-inline: ${desktopWideInlinePadding};
  }
`;
export const dividerLineStyle = css `
  &::after {
    content: '';
    position: absolute;
    inset: auto 0 -${createCustomSpacing(1 / 16)};
    block-size: ${createCustomSpacing(1 / 16)};
    background: var(${MegaMenuCSSCustomProperties.divider}, transparent);

    ${MediaQueries.untilDesktop} {
      width: 100vw;
      inset: auto -${mobileInlinePadding} 0;

      ${MediaQueries.tablet} {
        inset: auto -${tabletInlinePadding} 0;
      }
    }
  }
`;
